import { UnfoldLessHorizontalIcon } from './UnfoldLessHorizontalIcon';

/**
 * author: Google
 * id E533CB7E-48C2-4D9D-B935-B51C918703C0
 * name unfold-less-horizontal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unfold-less-horizontal.svg
 * tags
 */
export const ChevronDownUpIcon = UnfoldLessHorizontalIcon;
export default ChevronDownUpIcon